module.exports = __webpack_public_path__ + "static/Graph-27e53702096cd1e74321e84d769e386a.png";